import axios from 'axios'
import moment, { Moment } from "moment";

const url = process.env.REACT_APP_URL

export const getBPTable = async (checkbox: any, slider: [number, number], start: Date | undefined, end: Date | undefined) => {
  try {
    const data = await axios.get(url + "/bp/getBpTable", {
      params: { checkbox: checkbox, slider: slider, start: start, end: end }
    })
    return data.data
  } catch (err) {
    return err.code
  }
}

export const getCountCurrentBP = async (
  status: string[] | undefined = undefined,
  dateRange: { start: Moment | null | undefined, end: Moment | null | undefined } | undefined = undefined
) => {
  try {
    let data: any;
    if (dateRange?.start && dateRange?.end)
      data = await axios.get(url + '/bp/getCountCurrentBp',
        { params: { start: new Date(dateRange.start.toString()).toUTCString(), end: new Date(dateRange.end.toString()).toUTCString() } })
    else if (status)
      data = await axios.get(url + '/bp/getCountCurrentBp', { params: { status: status } })
    else
      data = await axios.get(url + '/bp/getCountCurrentBp')
    return data.data
  } catch (err) {
    return err
  }
}

export const getBpFromId = async (bpId: string) => {
  try {
    const data = await axios.get(url + '/bp/getBpFromId', {
      params: { bpId: Number(bpId) }
    })
    return data.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const getBpProgression = async (bpId: string) => {
  try {
    const data = await axios.get(url + "/bp/getBpProgression",
      { params: { bpId: bpId } })
    if (data.status === 200) return data.data
    else return null
  } catch (err) {
    return err
  }
}

export const getBPStatus = async () => {
  try {
    const res = await axios.get(url + '/bp/getBpStatus')
    return res.data
  } catch (err) {
    return err.code
  }
}

export const addBp = async (bpList: string[]) => {
  try {
    const res = await axios.post(url + '/bp/addBp', {
      bpList: bpList
    })
    return res.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const updateSku = async (bpId: number, sku) => {
  try {
    const res = await axios.post(url + "/bp/updateSku", {
      bpId: bpId,
      sku: sku
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const updateBp = async (bpId: number, bracelets: number) => {
  try {
    const res = await axios.post(url + "/bp/updateBp", {
      id: bpId,
      braceletCount: bracelets,
    })
    console.log(res)
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const deleteBp = async (bpId: Number) => {
  try {
    const res = await axios.post(url + '/bp/deleteBp', {
      id: bpId
    })
    console.log(res)
    return res
  } catch (err) {
    console.log(err)
  }
}